import React from 'react';
import { mergeSx } from '../../utils/sx/merge';
import { useTheme } from '../../hooks/useTheme';
import { styled } from '../../theme/styled';
import { SVGIconTokens } from '../svgIcon';
import hatchesUrl from '../../assets/shapes/hatchesRounded.svg?url';
import { SxProps } from '../../theme/model';

export type RoundelSize = 'normal' | 'small';
export type RoundelVariant = 'hatched';

export interface RoundelProps {
  children?: React.ReactNode;
  size?: RoundelSize;
  variant?: RoundelVariant;
  sx?: SxProps;
}

const ROUNDEL_SIZES: Readonly<Record<'desktop' | 'mobile', Record<RoundelSize, number>>> = {
  'desktop': {
    'small': 100, // no small size on desktop
    'normal': 100,
  },
  'mobile': {
    'small': 50,
    'normal': 80,
  },
};

const StyledBox = styled('div', { name: 'Roundel' })<{ size?: RoundelSize }>(({ theme, size = 'normal' }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '50%',
  boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.15)',
  boxSizing: 'border-box',
  padding: theme.spacing(size === 'normal' ? 2 : 1),
  backgroundColor: theme.palette.background.default,
  width: ROUNDEL_SIZES.mobile[size],
  height: ROUNDEL_SIZES.mobile[size],
  [SVGIconTokens.Size]: '100%',
  [theme.breakpoints.up('md')]: {
    width: ROUNDEL_SIZES.desktop[size],
    height: ROUNDEL_SIZES.desktop[size],
  },
}));

export const Roundel: React.FC<RoundelProps> = ({ variant, sx, ...props }) => {
  const theme = useTheme();
  return (
    <StyledBox
      sx={mergeSx(
        { background: variant === 'hatched' ? `${theme.palette.white} url(${hatchesUrl}) 70% 70% / 50% no-repeat` : theme.palette.white },
        sx,
      )}
      {...props}
    />
  );
};
